<template lang="html">
  <div class="table-scroll-container">
    <table class="table mb-0 table-striped">
      <thead>
        <tr>
          <th class="sticky-column border-0 pl-2.5">Nome</th>
          <th
            class="border-0 text-center"
            v-for="type in filteredPriceTypes"
            :key="type.id"
          >
            {{ type.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(product, index) in products" :key="product.variation_id">
          <td class="sticky-column td-4 pl-2.5">{{ product.variation_name }}</td>
          <td
            v-for="type in filteredPriceTypes"
            :key="`col-${product.variation_id}-${type.name}`"
            class="td-1 text-center"
            :class="{ disabled: product[type.name] === null }"
          >
            <div v-if="selectedRow !== product.variation_id">
              <span  v-if="product[type.name] !== null"  @click.prevent="selectedRow = product.variation_id">{{ addCurrencyMask(product[type.name].price)}}</span>
            </div>
            <d-input-group
              v-else-if="product[type.name] !== null"
              prepend="R$"
            >
              <input-currency
                :ref="`input-${index}-${type.name}`"
                model-index="price"
                :model="product[type.name]"
                placeholder="R$ 0,00"
                @focus="onPriceSelect(product[type.name])"
                @blur="updatePriceIfChanged(product[type.name], product.variation_id, type.name)"
                @keydown.enter.native.prevent="handleEnter($event, index, type.name)"
              />
            </d-input-group>
          </td>
        </tr>

        <tr v-if="products.length === 0">
          <td :colspan="filteredPriceTypes.length + 1" class="no-content">
            Ainda não tem nenhum produto cadastrado nessa categoria.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import InputCurrency from '_shared/InputCurrency';
import CurrencyMask from '_common/mixins/CurrencyMask';
import ProductService from '_services/rest/modules/product';
import { DEFAULT_PRICE_NAME } from './ProductModel';

export default {
  name: 'price-table-list-table',
  mixins: [CurrencyMask],
  components: {
    InputCurrency,
  },
  props: {
    priceTypes: {
      type: Array,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
    selectedPriceNames: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedRow: null,
      selectedPrice: null,
    };
  },
  computed: {
    filteredPriceTypes() {
      if (this.selectedPriceNames === 'ALL') return this.priceTypes;

      return this.priceTypes.filter(type =>
        this.selectedPriceNames.includes(type.name));
    },
  },
  methods: {
    ...mapActions(['activeAlert']),
    handleEnter(event, currentId, typeName) {
      if (event.shiftKey) {
        this.focusPrevious(currentId, typeName);
      } else {
        this.focusNext(currentId, typeName);
      }
    },
    focusNext(currentId, typeName) {
      this.focusRelativeInput(currentId, typeName, 1);
    },
    focusPrevious(currentId, typeName) {
      this.focusRelativeInput(currentId, typeName, -1);
    },
    focusRelativeInput(currentIndex, typeName, direction = 1) {
      let targetIndex = null;
      let targetProduct = null;
      let i = currentIndex;
      while (i + direction >= 0 && i + direction < this.products.length) {
        i += direction;
        const nextProduct = this.products[i];
        const hasInput = nextProduct[typeName] !== null && nextProduct[typeName] !== undefined;
        if (hasInput) {
          targetIndex = i;
          targetProduct = nextProduct;
          break;
        }
      }
      if (targetIndex === null) return;
      this.selectedRow = targetProduct.variation_id;
      const refKey = `input-${targetIndex}-${typeName}`;
      this.$nextTick(() => {
        const refItem = this.$refs[refKey];
        const inputComponent = Array.isArray(refItem) ? refItem[0] : refItem;
        if (inputComponent?.focusInput) {
          inputComponent.focusInput();
        }
      });
    },
    onPriceSelect(price) {
      if (!price) return;
      this.selectedPrice = { ...price };
    },
    updatePriceIfChanged(price, variationId = null, typeName = null) {
      if (!price || !this.selectedPrice) return;

      const oldPrice = parseFloat(this.selectedPrice.price || 0);
      const newPrice = parseFloat(price.price || 0);

      if (oldPrice === newPrice) return;

      const isDefault = typeName === DEFAULT_PRICE_NAME;

      const savePromise = isDefault
        ? ProductService.updatePrice({
          id: variationId,
          price: newPrice,
        })
        : ProductService.updateVariationPriceEntry(price);

      savePromise
        .then(() => {
          this.activeAlert({ message: 'Preço atualizado com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({
            message: `${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        });
    },
  },
};
</script>

<style scoped>
.table-scroll-container {
  overflow-x: auto;
  width: 100%;
}

tbody tr:nth-child(odd) .sticky-column {
  background-color: #F2F2F2;
}

tbody td {
  height: 48px;
  vertical-align: middle;
  padding-top: 0;
  padding-bottom: 0;
}

.sticky-column {
  position: sticky;
  min-width: 600px;
  left: 0;
  background: white;
  z-index: 99;
  box-shadow: 2px 0 0 rgba(0, 0, 0, 0.2);
}

.td-1 { width: 120px; min-width: 120px; }
.td-4 { width: 250px; min-width: 250px; }

.disabled { cursor: not-allowed; }

</style>
